// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.myabcwallet",
    name: "ABC Wallet",
    homepage: "https://myabcwallet.io/",
    image_id: "e689ea2b-cd49-4a1d-7812-424a0e0d9200",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/abc-wallet-safe-web3-wallet/id1642837445",
        android: "https://play.google.com/store/apps/details?id=io.myabcwallet.mpc&hl=en&gl=US",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "abc-wallet://abcwc",
        universal: "https://abcwalletconnect.page.link/?apn=io.myabcwallet.mpc&ibi=io.myabcwallet.mpc&isi=1642837445&efr=1&ofl=https://myabcwallet.io/download&link=https://myabcwallet.io",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map